<template>
  <div class="content">
    <base-block class="mb-0" rounded title="College Profile">
      <div class="text-center mt-0">
        <img
          class="text-center mt-0"
          src="../../assets/profile.png"
          width="50px"
        />
        <h3 class="mt-3">{{ college.name }}</h3>
      </div>
    </base-block>
    <br />
    <base-block>
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Details" active
            ><p>
              <base-block>
                <div class="bg-white rounded p-3 pr-3 pl-3 mb-3">
                  <div class="d-flex pro-det p-2">
                    <p class="mb-0 w-25">College Name</p>
                    <p class="mb-0 w-25 text-right">:</p>
                    <p class="mb-0 text-right w-50">
                      <b>{{ college.name }}</b>
                    </p>
                  </div>
                  <!-- <div class="d-flex pro-det p-2">
                    <p class="mb-0 w-25">User Name</p>
                    <p class="mb-0 w-25 text-right">:</p>
                    <p class="mb-0 text-right w-50">
                      <b>{{ college.username }}</b>
                    </p>
                  </div> -->
                  <div class="d-flex pro-det p-2">
                    <p class="mb-0 w-25">Url</p>
                    <p class="mb-0 w-25 text-right">:</p>
                    <p class="mb-0 text-right w-50">
                      <b>{{ college.url }}</b>
                    </p>
                  </div>
                </div>
              </base-block>
            </p></b-tab
          >
          <b-tab title="Subscription" 
            ><p>
              <b-table-simple
                responsive
                bordered
                striped
                table-class="table-vcenter"
              >

                <b-thead>
                  <b-tr>
                    <b-th class="text-center" style="width: 50px">S.NO</b-th>
                    <b-th class="text-center">Package Name</b-th>
                    <b-th class="text-center">Start Date</b-th>
                    <b-th class="text-center">End Date</b-th>
                    <b-th class="text-center">Students Count</b-th>
                    <b-th class="text-center">Status</b-th>
                    <b-th class="text-center">Action</b-th>
                    <b-th class="text-center">Users</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="(subscription, index) in subscriptions" :key="index">
                    <b-td class="text-center">
                      {{ index + 1 }}
                    </b-td>
                    <b-td class="text-center">{{ subscription.subscriptions.name }}</b-td>
                    <b-td class="text-center">{{ subscription.subscription_start_date ? subscription.subscription_start_date : "-"}}</b-td>
                    <b-td class="text-center">{{subscription.subscription_end_date ? subscription.subscription_end_date : "-"}}</b-td>
                    <b-td class="text-center">{{ subscription.students_count }}</b-td>
                    <b-td class="text-center">
                      <b-button
                        :class="{ 'btn-danger': !subscription.status }"
                        size="sm"
                        :variant="buttonVariant"
                        @click="
                          subscriptionStatus(subscription.id, index, subscription.status)
                        "
                      >
                        {{ subscription.status == 1 ? "Active" :
                        subscription.status ==2 ? "College Deactive" : "Admin Deactive" }}
                      </b-button>
                    </b-td>
                    <b-td class="text-center">                      
                      <b-button
                            size="sm"
                            variant="alt-primary"
                            @click="deleteSub(subscription.id)"
                            v-if="$store.getters.userDetails.includes('CAN_DELETE_COLLEGE_SUBSCRIPTION')"
                          >
                        <i class="fa fa-fw fa-trash"></i>
                      </b-button>
                    </b-td>
                    <b-td class="text-center">
                     <b-btn-group>
                   <router-link
                    :to="{ name: 'College Subscription User List', params: { id: subscription.id } }"
                  >
                    <b-button size="sm" variant="alt-primary">
                      <i class="fa fa-fw fa-eye"></i>
                    </b-button>
                  </router-link>
                </b-btn-group>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple></p
          ></b-tab>
          <b-tab title="Admin Lists"
            ><p>
              <b-table-simple
                responsive
                bordered
                striped
                table-class="table-vcenter"
              >

                <b-thead>
                  <b-tr>
                    <b-th class="text-center" style="width: 50px">S.NO</b-th>
                    <b-th class="text-center"> Name </b-th>
                    <b-th class="text-center"> Type </b-th>
                    <b-th class="text-center"> Date </b-th>
                    <b-th class="text-center"> Status </b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="(subscription, index) in admins" :key="index">
                    <b-td class="text-center">
                      {{ index + 1 }}
                    </b-td>
                    <b-td class="text-center">{{ subscription.username }}</b-td>
                    <b-td class="text-center">{{ subscription.type == 0 ? "Director" :
                       subscription.type == 1 ? "Department" :
                       subscription.type == 2 ? "HOD" :
                       subscription.type == 3 ? "Class" : "Student"}}</b-td>
                    <b-td class="text-center">{{ moment(subscription.created_at).format("DD-MM-YYYY") }}</b-td>
                    <!-- <b-td class="text-center">{{ subscription.status }}</b-td> -->
                    <b-td
                      class="text-center"
                      v-if="
                        $store.getters.userDetails.includes('CAN_STATUS_SUBSCRIPTION')
                      "
                    >
                      <b-button
                        :class="{ 'btn-danger': !subscription.status }"
                        size="sm"
                        :variant="buttonVariant"
                        @click="
                          toggleStatus(subscription.id, index, subscription.status)
                        "
                      >
                        {{ subscription.status ? "Active" : "Deactive" }}
                      </b-button>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple></p
          ></b-tab
          >
        </b-tabs>
      </div>
    </base-block>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
     college:[],
     subscriptions:[],
     admins:[],
      buttonVariant: "success" ,
      moment: moment,
    };
  },
  mounted() {
    this.loadData();
    this.getAdminLists();
  },
  methods: {
    async loadData() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/college/sub-index/${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.college = response.data.college;
            this.subscriptions = response.data.college.college_subscriptions;
          } else {
            this.$swal("Success", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getAdminLists(){
      await axios.get(`${this.$store.getters.baseUrl}/college/admin-list/${this.$route.params.id}`,
      {
        headers: {
          Authorization: `Bearer ${this.$store.getters.token}`,
        },
      })
      .then((response) => {
        console.log(response);
        if(response.data.status == "success"){
          this.admins = response.data.college_admins;
        }
        else{
          this.$swal("Success", response.data.message, "warning");
        }
      })
      .catch((error) => {
        console.log(error);
        this.$swal("Error", error.response.data.message, "error");
      });
    },
     async toggleStatus(id,index,status){
      await axios
        .get(`${this.$store.getters.baseUrl}/college_sub/admin-status/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.admins[index].status = status == 1 ? 0 : 1;
            this.$swal({
              text: `${response.data.message}`,
              icon: status ? "error" : "success",
            });
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    
     async subscriptionStatus(id,index,status){
      await axios
        .get(`${this.$store.getters.baseUrl}/college/sub-status/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.subscriptions[index].status = status == 1 ? 0 : 1;
            this.$swal({
              text: `${response.data.message}`,
              icon: status ? "success" : "error",
            });
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    
    async deleteSub(id) {
      await axios
        .get(`${this.$store.getters.baseUrl}/college/sub-edit/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loadData();
            this.$swal(
              "Success",
              "College Subscription deleted successfully",
              "success"
            );
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.message, "error");
        });
    },

  },
};
</script>